<script setup lang="ts">
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()


// Only show on Advisor routes
const isVisible = computed(() => {
    return route.path.startsWith('/advisor')
})
</script>

<template>
  <div v-if="isVisible" class="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-4 print:hidden">
      <!-- Expanded Panel -->
      <!-- Expanded Panel Removed - Direct Navigation Only -->

      <!-- Toggle Button -->
      <button 
        @click="router.push('/advisor/ai')" 
        class="h-14 w-14 rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-lg hover:shadow-xl hover:scale-105 transition flex items-center justify-center text-2xl"
      >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
      </button>
  </div>
</template>
